import { Fragment } from "react";
import { Link } from "react-router-dom";

const Singleproduct = ({ img, title, price, num }) => {
    return (
        <Fragment>
            <div class="card mx-auto" style={{ width: "18rem", marginTop: "20px" }}>
                <img src={img} class="card-img-top" alt="..." />
                <div class="card-body">
                    <h6 class="card-title"><i>{title}</i></h6>
                    <h6 class="card-text">{price}</h6>
                    {/* <button className='btn btn-primary mt-2 mb-2' onClick={
                    () => dispatch(CartSlice.actions.addtoCart({ img, title, price, id, num }))}>Add to Cart
                </button> */}
                    <Link to={`/product/${num}`}>  <button className='btn btn-primary mt-2 mb-2' >View details </button> </Link>
                </div>
            </div>
        </Fragment>


    )
}
export default Singleproduct;